import React from 'react';
import {action, extendObservable} from 'mobx';
import {observer} from 'mobx-react'
import TextareaAutosize from 'react-autosize-textarea';
import {injectIntl, intlShape} from 'react-intl';
import PropTypes from 'prop-types';
import {Popover, Button, Overlay} from 'react-bootstrap';
import DeleteButton from "../common_components/DeleteButton";


@injectIntl @observer
class Editable extends React.Component {
    constructor(props) {
        super(props);

        extendObservable(this, {
            showOptionPopover: false,
            showSuccess: false,
            textTooLarge: false,
        })
    }

    render() {
        const {intl, value, canEdit, placeholder, lineThrough, showDelete, canDelete, className} = this.props;
        const textStyle = {textDecoration: lineThrough ? 'line-through' : null};
        const showButtonContainer = showDelete && canDelete;
        const deleteButtonClass = showButtonContainer ? 'editable-container-with-buttons' : '';

        return (
            <div className={`editable-container ${deleteButtonClass} ${className}`}>

                <TextareaAutosize className="editable-text-area form-control"
                                  style={textStyle}
                                  ref={element => this.textAreaComponent = element}
                                  type='text'
                                 // value={value}
                                  defaultValue={value}
                                  placeholder={placeholder}
                                  onBlur={this.finishEdit}
                                  onKeyDown={this.checkKey}
                                  onChange={this.handleChange}
                                  readOnly={!canEdit}

                />


                <div className=" editable-buttons-container">
                    {this.renderDeleteButton()}
                    {this.renderOptionButton()}
                </div>

                {this.showSuccess && (
                    <div className="editable-check-mark-container">
                        <i className="fa fa-check-circle" style={{fontSize: '1.5em', color: '#1C8D8E'}}></i>
                    </div>
                )}

                {this.textTooLarge && (
                    <div className={'warning'} style={{}}>
                        <span className="fa fa-exclamation-circle"/>&nbsp;
                        {intl.formatMessage({id: 'warning_text_too_large'})}
                    </div>
                )}
            </div>
        );
    }


    renderOptionButton = () => {
        const {showOptionButton, optionButtonText} = this.props;

        if (!showOptionButton) {
            return null;
        }

        return (
            <React.Fragment>
                <Button bsStyle='default'
                        className="editable-option-button"
                        onClick={this.toggleShowOptionPopover}
                        ref={element => this.optionButtonRef = element}

                >
                    <i className="fa fa-caret-down"></i>
                </Button>

                <Overlay
                    show={this.showOptionPopover}
                    onHide={() => this.showOptionPopover = false}
                    rootClose
                    target={this.optionButtonRef}
                    placement="bottom"
                >
                    <Popover id="editable-option-button-popover"
                             className="react-board">
                        <div className="editable-buttons-container">
                            <Button bsStyle={'primary'} onClick={this.handleOptionButtonClick}>
                                {optionButtonText}
                            </Button>
                        </div>
                    </Popover>


                </Overlay>

            </React.Fragment>


        )
    };

    renderDeleteButton = () => {
        const {canDelete, showDelete, onDelete} = this.props;

        if (showDelete && canDelete) {
            return (
                <DeleteButton onDelete={onDelete}/>
            )
        }
    };

    checkKey = (e) => {
        const {value} = this.props;

        if (e.key === 'Enter' && !e.shiftKey) {
            this.preventPropagation(e);
            // this will trigger onBlur's finishEdit() method
            this.textAreaComponent.textarea.blur();
        }
    };

    finishEdit = (e) => {
        const {value} = this.props;

        if (e.target.value.trim() && value !== e.target.value && !this.textTooLarge) {
            this.props.onEdit(e.target.value);
            this.triggerSuccess();
        } else {
            e.target.value = value;
        }
    };


    handleChange = (e) => {
        if (e.target.value.length >= this.props.maxLength) {
            this.textTooLarge = true;
        } else {
            this.textTooLarge = false;
        }
    };

    preventPropagation = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // this is needed to prevent modal from close, it may be a bug of onKeyDown of TextareaAutosize
    escFunction = (e) => {
        const {value} = this.props;

        if (e.key === 'Escape') {
            this.preventPropagation(e);
            e.target.value = value;
            e.target.blur();
        }
    };


    triggerSuccess = () => {
        this.showSuccess = true;
    };

    @action
    toggleShowOptionPopover = () => {
        this.showOptionPopover = !this.showOptionPopover;
    };


    handleOptionButtonClick = () => {
        const {onOptionButtonClick} = this.props;

        this.toggleShowOptionPopover();
        onOptionButtonClick();
    };

    componentDidMount() {
        this.textAreaComponent.textarea.addEventListener("keydown", this.escFunction, true);
    }

    componentWillUnmount() {
        this.textAreaComponent.textarea.removeEventListener("keydown", this.escFunction, true);
    }

}


Editable.propTypes = {
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    intl: intlShape.isRequired,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    canEdit: PropTypes.bool,
    canDelete: PropTypes.bool,
    showDelete: PropTypes.bool,
    showOptionButton: PropTypes.bool,
    optionButtonText: PropTypes.string,
    onOptionButtonClick: PropTypes.func,
    maxLength: PropTypes.number,
};


export default injectIntl(Editable)

/*
import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import {injectIntl, intlShape} from 'react-intl';
import Text from 'react-format-text'

//import { confirm } from './libs/confirm';

class Editable extends React.Component {
    constructor(props) {
        super(props);
        this.finishEdit = this.finishEdit.bind(this);
        this.checkEnter = this.checkEnter.bind(this);
        this.edit = this.edit.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.renderEdit = this.renderEdit.bind(this);
        this.renderValue = this.renderValue.bind(this);
        this.renderDeleteButton = this.renderDeleteButton.bind(this);
        this.state = {
            editing: false
        };
    }

    render() {
        const {value, onEdit, onDelete, intl, ...rest} = this.props;
        const editing = this.state.editing;

        return (
            <div className="editable-div-container relative-position">
                {editing ? this.renderEdit() : this.renderValue()}
            </div>
        );
    }


    renderEdit() {
        return (<TextareaAutosize type='text'
                                  autoFocus={true}
                                  defaultValue={this.props.value}
                                  onBlur={this.finishEdit}
                                  onKeyPress={this.checkEnter}
                                  onClick={this.preventPropagation}
        />);
    }

    renderValue() {
        const {onDelete, canDelete, canEdit, showDelete} = this.props;
        return (
            <div className="editable-div-value-container">
                <Text className='value'>{this.props.value}</Text>
                <div className="editable-buttons-container">
                    {canEdit ? this.renderEditButton() : null}
                    {canEdit && showDelete ? this.renderDeleteButton() : null}
                </div>
            </div>
        );
    }

    edit(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            editing: true
        });
    }


    onDelete(e) {
        e.preventDefault();
        e.stopPropagation();
        this.props.onDelete();
        /*
        const {intl, onDelete} = this.props;
        const confiramtion = intl.formatMessage({id: 'are_you_sure_delete'});
        const okLabel = intl.formatMessage({id: 'ok'});
        const cancelLabel = intl.formatMessage({id: 'cancel'});
        const title = intl.formatMessage({id: 'warning'});

        confirm(confiramtion, {title: title, okLabbel: okLabel, cancelable: cancelLabel } ).then(() => {
            console.log('proceed!') ;
            onDelete();
        }, () => {
            console.log('cancel!');
        });

    }

    checkEnter(e) {
        if (e.key === 'Enter') {
            this.finishEdit(e);
        }
    }

    finishEdit(e) {
        this.props.onEdit(e.target.value);
        this.setState({
            editing: false
        });
    }

    renderEditButton() {
        return (
            <button onClick={this.edit}
                    className="editable-edit-button btn-transparent delete glyphicon glyphicon-pencil"/>
        )
    }

    renderDeleteButton() {
        return (
            <button onClick={this.onDelete}
                    className="editable-delete-button btn-transparent delete glyphicon glyphicon-trash"/>
        )
    }


    preventPropagation(e) {
        e.preventDefault();
        e.stopPropagation();
    }
}


Editable.propTypes = {
    intl: intlShape.isRequired
};


export default injectIntl(Editable)
*/